var calculateLineStackedRange = function (data, minValue, maxValue, keys) {
    var minimumRange = 0;
    var maximumRange = 0;
    data.forEach(function (item) {
        keys.reduce(function (acc, keyName) {
            var value = item[keyName];
            acc += value;
            if (acc < minimumRange)
                minimumRange = acc;
            if (acc > maximumRange)
                maximumRange = acc;
            return acc;
        }, 0);
    });
    var minimum = minValue === 'auto' ? minimumRange : minValue;
    var maximum = maxValue === 'auto' ? maximumRange : maxValue;
    return {
        minimum: minimum,
        maximum: maximum,
    };
};
export default calculateLineStackedRange;
